<template>
    <div>
        <div v-if="query && query.length">
            <div class="lovemap-item-query" v-for="(item,key) of query" :key="key">
                <div>
                    <span>
                        #{{key + 1}}
                    </span>
                    <span class="lovemap-item-query__current" v-if="item.ID == ID">
                        Current post in query
                    </span>
                </div>

                <div>
                    Lovemap product ID: {{item.ID}}
                </div>
                <div>
                    Order ID: {{item.orderID}}
                </div>
            </div>
        </div>
        <div v-else>
            No products in query
        </div>
    </div>
</template>

<script>
    export default {
        name: "TxRendererQuery",
        data() {
            return {
                query: null
            }
        },
        created() {
            this.getQuery();
        },
        mounted() {
            document.body.querySelector('#lovemap-query').appendChild(this.$el);
            this._interval = setInterval(this.getQuery, 20000)
        },
        beforeDestroy() {
            this.$el.remove();
            clearInterval(this._interval);
        },
        computed: {
            wp_rest() {
                return lovemap.rest
            },
            ID() {
                return ID
            }
        },
        methods: {
            async getQuery() {
                try {
                    let {data} = await this.$http({
                        method: 'GET',
                        url: `${this.wp_rest}lm/v1/lovemap/query`,
                    });
                    this.query = data
                } catch (e) {
                    console.error(e)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .lovemap-item-query {
        margin-top: 10px;
        margin-bottom: 10px;
        border: 1px solid #ccc;
        padding: 5px;

        &__current {
            font-weight: bold;
        }
    }
</style>